export const loadingLabel = {
  de: 'Wird geladen',
  en: 'Loading',
  sv: 'Laddar',
};
